import React, { Component } from 'react';
import Tooth from './Tooth';
import ChartingModal from './ChartingModal';
import ChartingTimeline from '../../commons/Charting/ChartingTimeline';
import { findOne } from '../../actions/permissions';

let $ = window.jQuery;

export default class Index extends Component {

    state = {
        chart: 'both', // tooth_child, tooth_adult, both
        tooth_child: {
            q2: {
                pos: 'left',
                num_array: [55,54,53,52,51]
            },
            q1: {
                pos: 'right',
                num_array: [61,62,63,64,65]
            },
            q3: {
                pos: 'left',
                num_array: [85,84,83,82,81]
            },
            q4: {
                pos: 'right',
                num_array: [71,72,73,74,75]
            }
        },
        tooth_adult: {
            q2: {
                pos: 'left',
                num_array: [18,17,16,15,14,13,12,11]
            },
            q1: {
                pos: 'right',
                num_array: [21,22,23,24,25,26,27,28]
            },
            q3: {
                pos: 'left',
                num_array: [48,47,46,45,44,43,42,41]
            },
            q4: {
                pos: 'right',
                num_array: [31,32,33,34,35,36,37,38]
            }
        },
        toothNumber: 0,
        selectedToothId: '',
        timeline: []
    };

    openModal = (e, toothNumber) => {
        if (! findOne(this.props.permissions, ['charting.add', 'charting.*'])) {
            this.props.showNotification('error', 'You dont have the correct permission to create a new chart');

            return;
        }

        this.setState({
            toothNumber: toothNumber
        });

        $('#setTooth').modal('show');
    };

    openTimelineModal = (timeline, selectedToothId) => {
        this.setState({
            timeline,
            selectedToothId
        }, () => {
            $('#chartingTimelineModal').modal('show');
        });
    };

    updateTooth = () => {

    };

    componentDidMount() {

    }

    render() {
        return(
            <div id="tooth_chart">
                <h4><strong className="pull-left">LEFT</strong><strong className="pull-right">RIGHT</strong></h4>
                <div className="clearfix"></div>
                <h5><strong>TEMPORARY TEETH</strong></h5>
                <div className={ this.state.chart !== 'tooth_adult' ? 'row' : 'hide' }>
                    <div className="col-md-6 col-sm-6 col-xs-6">
                        <Tooth toothNumbers={this.state.tooth_child.q2.num_array}
                               openModal={this.openModal}
                               openTimelineModal={this.openTimelineModal}
                               toothPos={this.state.tooth_child.q2.pos}
                               {...this.props} />
                    </div>
                    <div className="col-md-6 col-sm-6 col-xs-6">
                        <Tooth toothNumbers={this.state.tooth_child.q1.num_array}
                               openModal={this.openModal}
                               openTimelineModal={this.openTimelineModal}
                               toothPos={this.state.tooth_child.q1.pos}
                               {...this.props} />
                    </div>
                </div>
                <h5><strong>PERMANENT TEETH</strong></h5>
                <div className={ this.state.chart !== 'tooth_child' ? 'row' : 'hide' }>
                    <div className="col-md-6 col-sm-6 col-xs-6">
                        <Tooth toothNumbers={this.state.tooth_adult.q2.num_array}
                               openModal={this.openModal}
                               openTimelineModal={this.openTimelineModal}
                               toothPos={this.state.tooth_child.q2.pos}
                               {...this.props} />
                    </div>
                    <div className="col-md-6 col-sm-6 col-xs-6">
                        <Tooth toothNumbers={this.state.tooth_adult.q1.num_array}
                               openModal={this.openModal}
                               openTimelineModal={this.openTimelineModal}
                               toothPos={this.state.tooth_child.q1.pos}
                               {...this.props} />
                    </div>
                </div>
                <hr/>
                <h5><strong>PERMANENT TEETH</strong></h5>
                <div className={ this.state.chart !== 'tooth_child' ? 'row' : 'hide' }>
                    <div className="col-md-6 col-sm-6 col-xs-6">
                        <Tooth toothNumbers={this.state.tooth_adult.q3.num_array}
                               openModal={this.openModal}
                               openTimelineModal={this.openTimelineModal}
                               toothPos={this.state.tooth_child.q3.pos}
                               {...this.props} />
                    </div>
                    <div className="col-md-6 col-sm-6 col-xs-6">
                        <Tooth toothNumbers={this.state.tooth_adult.q4.num_array}
                               openModal={this.openModal}
                               openTimelineModal={this.openTimelineModal}
                               toothPos={this.state.tooth_child.q4.pos}
                               {...this.props} />
                    </div>
                </div>
                <h5><strong>TEMPORARY TEETH</strong></h5>
                <div className={ this.state.chart !== 'tooth_adult' ? 'row' : 'hide' }>
                    <div className="col-md-6 col-sm-6 col-xs-6">
                        <Tooth toothNumbers={this.state.tooth_child.q3.num_array}
                               openModal={this.openModal}
                               openTimelineModal={this.openTimelineModal}
                               toothPos={this.state.tooth_child.q3.pos}
                               {...this.props} />
                    </div>
                    <div className="col-md-6 col-sm-6 col-xs-6">
                        <Tooth toothNumbers={this.state.tooth_child.q4.num_array}
                               openModal={this.openModal}
                               openTimelineModal={this.openTimelineModal}
                               toothPos={this.state.tooth_child.q4.pos}
                               {...this.props} />
                    </div>
                </div>

                <ChartingModal {...this.props} toothNumber={this.state.toothNumber}
                               updateTooth={this.updateTooth} />

                <div id="toothSurfaceValidation" className="modal fade in" tabIndex="-1" aria-hidden="true">
                  <div className="modal-content">
                    <h4 className="modal-title"></h4>
                  </div>
                  <div className="modal-body text-center">
                    <p>Please select a procedure first.</p>         
                  </div>
                </div>

                <ChartingTimeline timeline={this.state.timeline} toothId={this.state.selectedToothId} />
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/charting/Index.js
 **/